import { nl } from './nl';
import { en } from './en';
import { de } from './de';
import { fr } from './fr';
import { es } from './es';
import { it } from './it';
import { pt } from './pt';
import { pl } from './pl';
import { tr } from './tr';
import { ar } from './ar';
import { ru } from './ru';
import { uk } from './uk';
import { zh } from './zh';
import { ja } from './ja';
import { ko } from './ko';
import { hu } from './hu';
import type { Handleiding } from './soort';

/**
 * De handleiding in de taal van de lezer.
 *
 * ALLE ZESTIEN TALEN, net als de schermteksten. De terugval op Engels blijft
 * staan voor het geval hier ooit een taal bijkomt zonder eigen handleiding:
 * een gast die een taal aanwees die we nog niet hebben, leest eerder Engels
 * dan Nederlands.
 *
 * LET OP BIJ EEN NIEUWE TAAL. Elk blok uit de groep "gebruik" heeft een
 * ingesproken versie in client/public/handleiding/, en die wordt gezocht op
 * `code`-`sleutel`. Een taal die je hier toevoegt zonder
 * `npm run handleiding:spraak --workspace server` te draaien, krijgt een
 * afspeelknop die niets doet. Tekst en audio horen in dezelfde slag.
 */
const TALEN: Record<string, Handleiding> = {
  nl,
  en,
  de,
  fr,
  es,
  it,
  pt,
  pl,
  tr,
  ar,
  ru,
  uk,
  zh,
  ja,
  ko,
  hu,
};

/** Talen waarvoor de handleiding echt geschreven is, niet de terugval. */
export const HANDLEIDING_TALEN = Object.keys(TALEN);

export function handleiding(taalcode: string): Handleiding {
  const kort = taalcode.split('-')[0] ?? '';
  return TALEN[kort] ?? en;
}

export type { Handleiding, HandleidingDeel } from './soort';
